import { render, staticRenderFns } from "./PedidoKanbanLane.vue?vue&type=template&id=70dc9e42&scoped=true"
import script from "./PedidoKanbanLane.vue?vue&type=script&lang=js"
export * from "./PedidoKanbanLane.vue?vue&type=script&lang=js"
import style0 from "./PedidoKanbanLane.vue?vue&type=style&index=0&id=70dc9e42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dc9e42",
  null
  
)

export default component.exports